import { Directive, OnInit, Input, AfterViewInit, ElementRef, Renderer2 } from '@angular/core';
import { AuthService } from '../_services/auth.service';

@Directive({
  selector: '[appHasRoleDisable]'
})
export class HasRoleDisableDirective implements AfterViewInit {
  @Input() appHasRoleDisable: string[];

  constructor(private element: ElementRef, private renderer: Renderer2, private authService: AuthService) {}
  ngAfterViewInit(): void {
    if (!this.authService.roleMatch(this.appHasRoleDisable)) {

      const elements = this.element.nativeElement.getElementsByTagName('input');
      const elementsArray = Array.prototype.slice.call(elements);
      elementsArray.forEach(element => __ngRendererSetElementAttributeHelper(this.renderer, element, 'disabled', 'disabled'));

      const elementsKS = this.element.nativeElement.getElementsByTagName('kendo-switch');
      const elementsArrayKS = Array.prototype.slice.call(elementsKS);
      elementsArrayKS.forEach(element => __ngRendererSetElementAttributeHelper(this.renderer, element, 'disabled', 'disabled'));

      const elementsKSB = this.element.nativeElement.getElementsByTagName('kendo-combobox');
      const elementsArrayKSB = Array.prototype.slice.call(elementsKSB);
      elementsArrayKSB.forEach(element => __ngRendererSetElementAttributeHelper(this.renderer, element, 'disabled', 'disabled'));
    }
  }

}

type AnyDuringRendererMigration = any;

function __ngRendererSplitNamespaceHelper(name: AnyDuringRendererMigration) {
    if (name[0] === ":") {
        const match = name.match(/^:([^:]+):(.+)$/);
        return [match[1], match[2]];
    }
    return ["", name];
}

function __ngRendererSetElementAttributeHelper(renderer: AnyDuringRendererMigration, element: AnyDuringRendererMigration, namespaceAndName: AnyDuringRendererMigration, value?: AnyDuringRendererMigration) {
    const [namespace, name] = __ngRendererSplitNamespaceHelper(namespaceAndName);
    if (value != null) {
        renderer.setAttribute(element, name, value, namespace);
    }
    else {
        renderer.removeAttribute(element, name, namespace);
    }
}
